import React from 'react';

const FormattedContent = ({ htmlContent }) => {
  return (
    <div className="formatted-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default FormattedContent;
